import React, { Component } from 'react';
import i18n from 'i18n-react';

import { storageKeys } from 'config/settings.json';

import BackImage from 'components/BackImage';
import { ContentHeader } from 'components/ContentHeader/ContentHeader';
import ShowcaseCollection from 'components/ShowcaseCollection';
import APIHandler from 'config/APIHandler';
import DataHandler from 'config/DataHandler';
import StorageHandler from 'config/StorageHandler';
import getFeatureFlags from 'helpers/getFeatureFlags';
import PropTypes from 'prop-types';
import { legacyRemCss } from 'helpers/legacyRem';

export default class ShowcaseCollectionView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stands: {},
      language: 'en',
      enableIconAsImage: false,
    };
  }

  UNSAFE_componentWillMount() {
    this.getStandsAndFloor();
  }

  async getStandsAndFloor() {
    // App ID hardcoded until all are set in backend
    const appId = await DataHandler.matchAppId();
    const lang = await StorageHandler.load(storageKeys.lang);
    this.setState({ language: lang.langFile });

    const flags = await getFeatureFlags();
    this.setState({ enableIconAsImage: flags.enable_showcase_icon_as_image });

    const exhbitions = await APIHandler.getExhibitionStands(appId);
    exhbitions.forEach((stand) => {
      this.getItemsPerCategory(stand.tiles, stand.title, lang.langFile);
    });
  }

  async getItemsPerCategory(stands, category, lang) {
    let ids = '';
    stands.forEach((stand) => {
      ids += `&ids[]=${stand.company_id}`;
    });

    const items = this.state.stands;
    const allStands = await APIHandler.getStands(ids, lang);
    if (!category || !Array.isArray(allStands.items)) return;
    items[category] = allStands.items;
    this.setState({ stands: items });

    StorageHandler.load(storageKeys.user).then((userObj) => {
      let email = 'guest';
      if (userObj && userObj.response) {
        ({ email } = userObj.response);
      }
      APIHandler.trackSearch(ids, email);
    });
  }

  render() {
    const { stands, language, enableIconAsImage } = this.state;
    const params = new URLSearchParams(window.location.search);
    if (Object.keys(stands).length === 0) {
      return <div />;
    }

    return (
      <div className="showcaseCollectionViewContainer">
        <BackImage darken />
        <div className="showcaseContainer">
          <ContentHeader header={i18n.translate('nav.showcases')} icon="" line={false} pageHeader />
          <div className="showcaseCountriesGrid">
            {Object.entries(stands).map(([key, stand]) => {
              return (
                Array.isArray(stand) &&
                stand.length > 0 && (
                  <React.Fragment key={key}>
                    {Object.entries(stands).length > 1 && <h3 className="showcaseCategory">{key}</h3>}
                    <ShowcaseCollection
                      stands={stand}
                      category={key}
                      key={key}
                      language={language}
                      enableIconAsImage={enableIconAsImage}
                    />
                  </React.Fragment>
                )
              );
            })}
            <style>
              {
                '\
            .fancybox-slide--iframe .fancybox-content { max-width  : 960px; margin: 0; }'
              }
            </style>
            {params.get('header') && (
              <style>
                {`.cookieConsent { display: none !important; } .header { display: none !important; } .showcaseContainer { margin-top: ${legacyRemCss(3)} !important; } nav { display: none !important; }`}
              </style>
            )}
          </div>
        </div>
      </div>
    );
  }
}

ShowcaseCollectionView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape().isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

ShowcaseCollectionView.defaultProps = {
  // headerSubtitle: '',
};
